var cart = new Vue({
    el: '#shop-cart',
    delimiters: ['${', '}'],
    data: {
        items:[],
        itemCount:0,
        originalTotalPrice:0,
        TotalDiscount:0,
        TotalPrice:0,
        itemsSubtotalPrice:0,
        currency:'',
        isChoose:false,
        variantTitle:null,
        chooseItem:{},
        chooseVariants:{},
        updateVariantId:0,
        updateVariantPrice:0
    },
    methods: {
        add: function (variantId,quantity) {
            // loading
            var qty = quantity  +1
            this.updateQuantity(variantId,qty)
        },
        reduce:function (variantId,quantity){
            var qty;
            if(quantity === 1)
            {
                qty = 1
            }else{
                qty = quantity -1
            }
            this.updateQuantity(variantId,qty)
        },
        updateQuantity(variantId,qty){
            var _this = this
            var data = { updates: {} };
            data.updates[variantId] = qty;
            $.post('/cart/update.js',data,function (response){
                _this.updateDate(JSON.parse(response))
            })
        },
        updateCurrency(value){
            var newValue = value / 100
            switch (this.currency)
            {
                case 'USD':
                    return '$'+newValue.toString()
            }
            return value;
        },
        updateDate(response)
        {
            console.log(response)
            this.items = response.items;
            this.currency = response.currency;
            this.itemCount = response.item_count;
            this.originalTotalPrice= response.original_total_price;
            this.TotalDiscount= response.total_discount;
            this.TotalPrice=response.total_price;
            this.itemsSubtotalPrice = response.items_subtotal_price;
        },
        deleteProduct(variantId){
            console.log('delete')
            var _this = this
            $.post('/cart/update.js', 'updates['+variantId+']=0',function (response){
                _this.updateDate(JSON.parse(response))
            })
        },
        showUpdateCart(item){
            this.chooseItem = item
            this.isChoose = true
            // 获取product
            var itemHandle = item.handle
            var _this = this;
            $.getJSON('/products/'+itemHandle+'.js',function (response){
                _this.chooseVariants = response.variants
                document.getElementById("per-hidden").classList.remove('hidden');
            })
        },
        closeCartUpdate(){
            this.isChoose = false
        },
        variantSelect(value){
            if(value.available === false)
            {
                return ;
            }
            this.updateVariantId = value.id
            this.updateVariantPrice = value.price
            this.variantTitle = value.title;
        },
        updateCart(newVariantId,oldVariantId,qty){
            var _this = this
            $.post('/cart/add.js', {
                items: [
                    {
                        quantity: qty,
                        id: newVariantId,
                    }
                ]
            },function (response)
            {
                _this.updateDate(JSON.parse(response))
                _this.deleteProduct(oldVariantId)
                _this.isChoose = false;
            });
        },
        variantsClass(value,chooseId){
            if(value.available === false)
            {
                return 'variants-item variant-disable';
            }
            if(value.id === chooseId)
            {
                return 'variants-item variant-active'
            }
            return 'variants-item'
        },
        variantsMobileClass(value,chooseId){
            if(value.available === false)
            {
                return 'variants-item row-disable';
            }
            if(value.id === chooseId)
            {
                return 'variants-item row-choose'
            }
            return 'variants-item'
        },
    },
    mounted(){
        var _this = this
        $.post('/cart.json',function (response){
            _this.updateDate(response)
        })
    }
})